import React, { useMemo } from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer, Legend } from "recharts";

const processarDados = (data, intervalo) => {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);

    const vendasPorDataEVendedor = {};

    data.forEach((item) => {
        const dataFechamento = new Date(item.dataFechamento);
        dataFechamento.setHours(0, 0, 0, 0);

        const diferencaDias = (hoje - dataFechamento) / (1000 * 60 * 60 * 24);

        if (diferencaDias <= intervalo) {
            const dataFormatada = dataFechamento.toISOString().split("T")[0];

            if (!vendasPorDataEVendedor[dataFormatada]) {
                vendasPorDataEVendedor[dataFormatada] = {};
            }

            if (!vendasPorDataEVendedor[dataFormatada][item.vendedor]) {
                vendasPorDataEVendedor[dataFormatada][item.vendedor] = 0;
            }

            vendasPorDataEVendedor[dataFormatada][item.vendedor] += item.valor;
        }
    });

    return Object.keys(vendasPorDataEVendedor)
        .sort((a, b) => new Date(a) - new Date(b))
        .map((data) => ({
            data,
            ...vendasPorDataEVendedor[data],
        }));
};

const cores = ["#8884d8", "#82ca9d", "#ff7300", "#ff0000", "#00ff00", "#0000ff", "#ff00ff"];

const GraficoVendas = ({ rawData, intervalo = 60 }) => {
    const dadosFormatados = useMemo(() => {
        console.log("📊 Recalculando dados do gráfico...");
        return processarDados(rawData || [], intervalo);
    }, [rawData, intervalo]);

    const vendedores = useMemo(() => [...new Set((rawData || []).map((item) => item.vendedor))], [rawData]);

    if (!rawData || rawData.length === 0) return <p>Nenhum dado disponível.</p>;

    return (
        <ResponsiveContainer width="90%" height={400}>
            <LineChart data={dadosFormatados}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="data" tickFormatter={(tick) => tick.split("-").reverse().join("/")} />
                <YAxis />
                <Tooltip />
                <Legend />
                {vendedores.map((vendedor, index) => (
                    <Line
                        key={vendedor}
                        type="monotone"
                        dataKey={vendedor}
                        stroke={cores[index % cores.length]}
                        strokeWidth={3}
                        name={`${vendedor}`}
                    />
                ))}
            </LineChart>
        </ResponsiveContainer>
    );
};

export default GraficoVendas;
